"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { HiOutlineDocumentText } from "react-icons/hi";
import { ChecklistCardEnum } from "./types";
import { useChecklistAnalytics } from "./utils";
export const ChecklistCardGold = () => {
  const $ = _c(7);
  const {
    ref,
    onLinkClick
  } = useChecklistAnalytics(ChecklistCardEnum.Gold);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex justify-between items-start gap-3 mb-2"><h3 className="text-base font-bold text-slate-800 dark:text-slate-100 leading-tight">Zaoszczędź przy zakupie!</h3><HiOutlineDocumentText className="text-gold-500 dark:text-gold-400 text-2xl" /></div>;
    t1 = <p className="text-sm text-slate-600 dark:text-slate-300 mb-4">Skorzystaj z checklisty zakupowej i dowiedz się jak możesz negocjować!</p>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onLinkClick) {
    t2 = <div className="mt-auto"><Link href="/checklista-zakupowa" onClick={onLinkClick} className="block w-full text-center px-4 py-2 bg-gold-500 text-white text-sm font-bold uppercase tracking-wide rounded-lg hover:bg-gold-600 dark:hover:bg-gold-400 transition-colors shadow-sm">Otwórz checklistę zakupową</Link></div>;
    $[2] = onLinkClick;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ref || $[5] !== t2) {
    t3 = <article ref={ref} className="group relative flex flex-col bg-amber-50 dark:bg-slate-900 rounded-xl border border-amber-200 dark:border-amber-800 transition-all duration-300 hover:shadow-tactical hover:-translate-y-1 hover:border-gold-400 dark:hover:border-gold-600 p-4 h-full">{t0}{t1}{t2}</article>;
    $[4] = ref;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};